import * as React from "react";
import * as ReactDOM from "react-dom";
import { ReactifySearchLiquidFactory, Search, useResults, useSearch, Sensors, Suggestions, CustomComponent } from "@usereactify/search";

import { InstantSearchResults } from "../Results/results";
import { Suggestions as SuggestionsResult } from "./suggestion";

const ReactifySearchFactory = new ReactifySearchLiquidFactory({
  mode: "instant-search",
  market: window.market.id,
  includeFields: ["*"],
  excludeFields: [],
  shopifyPermanentDomain: "bassike.myshopify.com",
  additionalComponentIds: ["InstantSearchProductFilter"],
});
const ReactifySearchProvider = ReactifySearchFactory.getProvider();
const ReactifySearchMountNode = ReactifySearchFactory.getMountNode();

export const InstantSearch = () => {
  const { searchTerm, setSearchTerm, submitSearchTerm, showInstantSearchResults, setShowInstantSearchResults } = useSearch();
  const { resultStats } = useResults();

  const handleSearch = React.useCallback((event) => {
    event.preventDefault();
    submitSearchTerm(searchTerm);
  }, [submitSearchTerm, searchTerm]);

  const submitSearchKey = React.useCallback((event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      handleSearch(event);
    }
    setShowInstantSearchResults(true);
  }, [handleSearch, setShowInstantSearchResults]);

  React.useEffect(() => {
    if (searchTerm) {
      document.body.classList.add("instant-search-active");
    } else {
      document.body.classList.remove("instant-search-active");
    }
  }, [searchTerm]);

  return (
    <div className="instant-search-content searchform">
      <form action="/search">
        <fieldset className="filter-input-wrapper">
        <label htmlFor="side-panel-search-input">search</label>
          <input
            id="side-panel-search-input"
            type="search"
            className="search-field"
            placeholder="Search for anything"
            value={searchTerm}
            name="q"
            onKeyDown={(e) => submitSearchKey(e)}
            onChange={(event) => setSearchTerm(event.target.value)}
            />
        </fieldset>
        <input type="hidden" enterKeyHint="search" />
      </form>

      <div className="instant-search-results">
        <Suggestions field="title" render={SuggestionsResult} />
        <InstantSearchResults />
      </div>
      {(searchTerm && showInstantSearchResults && resultStats?.numberOfPages > 0) && (
        <div className="search-button-wrapper">
          <button className="button solid-black btn-md w-100" onClick={handleSearch}><span>view {resultStats?.numberOfResults} results</span></button>
        </div>)}
    </div>
  )
}


ReactDOM.render(
  <React.StrictMode>
      <ReactifySearchProvider>
      <Sensors />
      <CustomComponent
        componentId="InstantSearchProductFilter"
        customQuery={() => {
          const query = {
            bool: {
              must: [
                { match: { published: true } }
              ],
              must_not: [
                { term: { tags: "hidden" } }
              ]
            }
          };
          return { query };
        }}
      />
      <InstantSearch />
    </ReactifySearchProvider>
  </React.StrictMode>,
  ReactifySearchMountNode
);
